import styled, { css } from 'styled-components'
import FlexRow from '@/ui/FlexRow'
import Segment from '@/ui/Segment'
import Icon from '@/ui/Icon'

export const ImageUploadWrapper = styled(
  ({ dashedBorder, hideBorder, disabled, ...rest }) => <Segment {...rest} />,
).attrs({
  basic: true,
})`
  ${({ dashedBorder, fluid, disabled, theme }) => css`
     {
      position: relative;
      border: none !important;
      outline: ${dashedBorder
        ? '1px dashed #2A5EF6'
        : '1px solid rgb(216, 218, 219)'} !important;
      background: #f8fafe !important;
      border-radius: 10px !important;
      width: ${fluid ? 'auto' : '117px'};
      height: ${fluid ? '200px' : '117px'};
      max-width: 100%;
      transition: background-color 0.2s;
      margin-top: 0 !important;

      img {
        border: 0;
        border-radius: 10px;
        max-width: 100%;
        max-height: 100%;
        width: 100%;
        height: auto;
        object-fit: cover;
        aspect-ratio: 1 / 1;
      }

      .icon.edit {
        position: relative;
        top: 0;
        left: 0;
      }

      ${!disabled &&
      css`
        ${theme.mediaQueries.mobile} {
          .segment {
            border: 0;
          }

          img {
            margin: auto;
            max-width: 300px;
          }
        }

        ${theme.mediaQueries.mobile} {
          .image-upload-options {
            display: none;
          }
        }
      `}
    }
  `}
`

export const DropContainer = styled(({ disabled, ...rest }) => (
  <FlexRow {...rest} />
)).attrs({
  noMargin: true,
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
})`
  ${({ disabled, theme }) => css`
    height: 100%;
    padding: 0.5em;
    text-align: center;
    border-radius: 10px !important;
    cursor: ${disabled ? 'default' : 'pointer'};
    background: ${disabled ? theme.colors.backgroundColor : 'none'};
  `}
`

export const DropLabel = styled.div`
  margin-top: 0.5em;
  font-size: 14px;
  font-weight: 300;
  color: #012d3e;
`

export const EditIconWrapper = styled.div`
  background: #0a5b8b;
  height: 24px;
  width: 24px;
  border-radius: 100%;
  position: absolute;
  top: calc(100% - 1em);
  left: calc(100% - 12px);
`

export const EditIcon = styled(Icon).attrs({
  button: true,
  name: 'icon-pencil',
  color: '#fff',
})`
  position: relative;
  top: 3px;
  left: 3px;
`
